import { Client } from 'urql';
import { streetPageQuery } from './streetPageQuery';

export const fetchStreetPage = async ({
  client,
  slug,
  toggleMediaPartnerBannerTemporaryCampaign,
}: {
  client: Client;
  slug: string;
  toggleMediaPartnerBannerTemporaryCampaign: boolean;
}) => {
  const { data, error } = await client
    .query(streetPageQuery, { slug, toggleMediaPartnerBannerTemporaryCampaign })
    .toPromise();
  return { data, error };
};
